// Frequency dropdown config items follow. These are broken out to allow for easier groking
// and grepping if/when things need to be changed.
const WEEKLY_FREQUENCY_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Weekly, Ending Monday',
        value: 'weekly_mon', // Weekly, anchored to Monday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Tuesday',
        value: 'weekly_tue', // Weekly, anchored to Tuesday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Wednesday',
        value: 'weekly_wed', // Weekly, anchored to Wednesday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Thursday',
        value: 'weekly_thu', // Weekly, anchored to Thursday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Friday',
        value: 'weekly_fri', // Weekly, anchored to Friday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Saturday',
        value: 'weekly_sat', // Weekly, anchored to Saturday
    },
    {
        type: 'option',
        label: 'Weekly, Ending Sunday',
        value: 'weekly_sun', // Weekly, anchored to Sunday
    },
];
const BIWEEKLY_FREQUENCY_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Monday',
        value: 'biweekly_mon', // Biweekly, anchored to Monday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Tuesday',
        value: 'biweekly_tue', // Biweekly, anchored to Tuesday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Wednesday',
        value: 'biweekly_wed', // Biweekly, anchored to Wednesday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Thursday',
        value: 'biweekly_thu', // Biweekly, anchored to Thursday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Friday',
        value: 'biweekly_fri', // Biweekly, anchored to Friday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Saturday',
        value: 'biweekly_sat', // Biweekly, anchored to Saturday
    },
    {
        type: 'option',
        label: 'Bi-Weekly, Ending Sunday',
        value: 'biweekly_sun', // Biweekly, anchored to Sunday
    },
];
const QUARTERLY_FREQUENCY_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Quarterly, Ending December 31st',
        value: 'quarterly_dec', // Quarterly, ending on December 31st
    },
    {
        type: 'option',
        label: 'Quarterly, Ending November 30th',
        value: 'quarterly_nov', // Quarterly, ending on November 30th
    },
    {
        type: 'option',
        label: 'Quarterly, Ending October 31st',
        value: 'quarterly_oct', // Quarterly, ending on October 31st
    },
];
const PARENT_FREQUENCY_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Daily',
        value: 'daily', // Daily, including weekends
    },
    {
        type: 'option',
        label: 'Market Daily',
        value: 'market_daily', // Daily, Monday through Friday
    },
    {
        type: 'option',
        label: 'Weekly',
        sublist: WEEKLY_FREQUENCY_DROPDOWN_OPTIONS,
    },
    {
        type: 'option',
        label: 'Bi-Weekly',
        sublist: BIWEEKLY_FREQUENCY_DROPDOWN_OPTIONS,
    },
    {
        type: 'option',
        label: 'Monthly',
        value: 'monthly', // Monthly, ending on the last day of the month
    },
    {
        type: 'option',
        label: 'Market Monthly', // Business Monthly, ending on the last weekday of the month
        value: 'market_monthly', // Business Monthly, ending on the last weekday of the month
    },
    {
        type: 'option',
        label: 'Quarterly',
        sublist: QUARTERLY_FREQUENCY_DROPDOWN_OPTIONS,
    },
    {
        type: 'option',
        label: 'Market Quarterly',
        value: 'market_quarterly', // Business Quarterly, ending on the last weekday in December
    },
    {
        type: 'option',
        label: 'Annual',
        value: 'yearly', // Annually, ending on December 31st
    },
    {
        type: 'option',
        label: 'Semi-Annual',
        value: 'semi_yearly', // Semi-Annual, 6 Months first date
    },
    {
        type: 'option',
        label: 'Market Annual',
        value: 'market_yearly', // Business Annually, ending on the last weekday in December
    },
    {
        type: 'option',
        label: 'Unchanged Frequency',
        value: '',
    },
];
export const TIME_SERIES_AGGREGATION_DROPDOWN_OPTIONS = {
    list: [
        {
            type: 'option',
            label: 'Sum',
            value: 'sum',
        },
        {
            type: 'option',
            label: 'Mean',
            value: 'mean',
        },
        {
            type: 'option',
            label: 'Median',
            value: 'median',
        },
        {
            type: 'option',
            label: 'Maximum',
            value: 'max',
        },
        {
            type: 'option',
            label: 'Minimum',
            value: 'min',
        },
        {
            type: 'option',
            label: 'Beginning of Period',
            value: 'first',
        },
        {
            type: 'option',
            label: 'End of Period (Default)',
            value: 'last',
        },
    ],
};
export const TIME_SERIES_FILL_METHOD_DROPDOWN_OPTIONS = {
    list: [
        {
            type: 'option',
            label: 'No Fill',
            value: 'no_fill',
        },
        {
            type: 'option',
            label: 'Fill Backward',
            value: 'backward',
        },
        {
            type: 'option',
            label: 'Fill Forward',
            value: 'forward',
        },
    ],
};
export const TIME_SERIES_FREQUENCY_DROPDOWN_OPTIONS = {
    list: PARENT_FREQUENCY_DROPDOWN_OPTIONS,
};
